import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
interface BuildersProfileSkeletonProps {
  builderNameWidth: number;
}
function BuildersProfileSkeleton(t0) {
  const $ = _c(7);
  const {
    builderNameWidth
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className="h-8 w-8 rounded-full" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-5.5 w-5" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${builderNameWidth * 4}px`;
  let t4;
  if ($[2] !== t3) {
    t4 = <div className="flex items-center gap-1">{t2}<Skeleton className="h-5.5" style={{
        width: t3
      }} /></div>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Skeleton className="h-5 w-21.5" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = <div className="flex items-center gap-2 md:gap-4">{t1}<div className="flex flex-col gap-1">{t4}{t5}</div></div>;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
export { BuildersProfileSkeleton };